import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { FirebaseFile, makeId } from "sweet-global";
import ImageIcon from "sweet-web/components/icons/ImageIcon";
import { colors } from "sweet-web/lib/styles";
import { UploadUserImage } from "sweet-web/redux/user/actions";

const Wrapper = styled.div<{ hasImage: boolean }>`
  align-self: center;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  transition: all 150ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  &:hover {
    .single-image-input-photo-icon {
      opacity: 1;
    }
  }
`;

const ImageInput = styled.input`
  display: none;
`;

const EmptyImage = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 40px;
  background-color: ${colors.white};
  border: 1px solid ${colors.lightGray};
  transition: all 150ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  &:hover {
    box-shadow: rgba(0, 0, 0, 0.08) 0 3px 10px 0;
  }
`;

const Image = styled.img`
  width: 80px;
  height: 80px;
  background-color: ${colors.gray};
  object-fit: cover;
  border-radius: 40px;
`;

const PhotoIconWrapper = styled.div<{ hasImage: boolean }>`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  opacity: ${props => (props.hasImage ? 0 : 1)};
  background-color: ${props =>
    props.hasImage ? "rgba(0, 0, 0, 0.2)" : "none"};
  border-radius: 40px;
  pointer-events: none;
`;

type Props = {
  value: string;
};
const SingleImageInput: React.FC<Props> = props => {
  const inputRef = useRef(null);
  const dispatch = useDispatch();

  return (
    <Wrapper
      onClick={() => {
        inputRef.current.click();
      }}
      hasImage={Boolean(props.value)}
    >
      <ImageInput
        ref={inputRef}
        type="file"
        onChange={async e => {
          const file = e.target.files[0];
          await dispatch(UploadUserImage(file));
        }}
      />

      {props.value && <Image src={props.value} />}
      {!props.value && <EmptyImage />}
      <PhotoIconWrapper
        className="single-image-input-photo-icon"
        hasImage={Boolean(props.value)}
      >
        <ImageIcon
          color={Boolean(props.value) ? colors.white : colors.gray}
          size={20}
          style={{ marginTop: 5 }}
        />
      </PhotoIconWrapper>
    </Wrapper>
  );
};

export default SingleImageInput;
